import { useQuery } from '@tanstack/react-query';

import { weatherApi } from 'api/weather';

export const WEATHER_REPORT_LIST_QUERY_KEY = 'weatherReportList';

export const weatherReportListQueryKeys = {
    all: [WEATHER_REPORT_LIST_QUERY_KEY],
    list: () => [...weatherReportListQueryKeys.all, 'list'],
};

/**
 * Fetches the list of requested weather reports.
 *
 * @param {Omit<import('@tanstack/react-query').UseQueryOptions<Array, Error>, 'queryKey' | 'queryFn'>} [queryOptions={]}
 * @returns {import('@tanstack/react-query').UseQueryResult<Array, Error>}
 */
export function useWeatherReportListQuery(queryOptions = {}) {
    return useQuery({
        queryKey: weatherReportListQueryKeys.list(),
        queryFn: async () => {
            const response = await weatherApi.getReportList();
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch weather reports');
            }
            return response.data?.weatherReports ?? [];
        },
        staleTime: 30 * 1000,
        ...queryOptions,
    });
}
